import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { withSnackbar } from "./../../../../components/Message/Alert";
import { InputBaseField } from '../../../../components/InputField/InputField';
import { formateMdnNumber, validatePhoneNumber, IsVerizonSIM, handleNumberKeyPress } from '../../../../components/Common/Extensions';
import { PostDataAPI } from '../../../../Services/APIService';
import DialogLoader from '../../../../components/Loader/DialogLoader';
import { DraggableComponent, Label } from '../../../../components/UiElements/UiElements';

function ChangePhoneNumberDialog({ dialogOpenClose, handleClose, handleSuccessClose, fromDashboard, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ zipCode: '', mdnNumber: formateMdnNumber(props.mdnNumber), icc: props.icc });
    const [accountNumber, setAccountNumber] = useState(props.accountNumber);
    const [emailAddress, setEmailAddress] = useState(props.emailAddress);
    const [userName, setUserName] = useState(props.userName);
    const [errorMessages, setErrorMessages] = useState({
        errorZipCode: false, errorZipCodeLength: false
    })

    const reconnectMDN = () => {
        let errorList = [];
        if (!state.mdnNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }
        if (state.mdnNumber && !validatePhoneNumber(state.mdnNumber)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }
        if (state.imei && state.imei.length < 15) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorImei: false
            }));
        }

        if (errorList.length < 1) {
            //reference number is any random number, the api will response with this reference number
            var obj = {
                MDN: state.mdnNumber,
                userName: userName,
                emailAddress: emailAddress,
                accountNumber: accountNumber,
                lineUserName: props.lineUserName,
                loginUserName: props.loginUserName,
                imei: state.imei
            };
            //var obj = {
            //    wirelessId: wirelessId,
            //    MDN: mdn,
            //    userName: customerInformation?.objCustomerInfo?.fullName,
            //    emailAddress: customerInformation?.objCustomerInfo?.email,
            //    accountNumber: accountNumber,
            //    isPrepaid: isPrepaid,
            //    loginUserName: loginUser.firstName,
            //    lineUserName: lineName,
            //};
            setIsLoading(true);
            var method = "telispire/reconnectLineByMDN";
            
            PostDataAPI(method, obj, true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data != null) {
                    //showMessage("Success", "Line reconnected successfully.", "success", 3000);
                    handleSuccessClose("Line reconnected successfully.");
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
        }

    }
    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    useEffect(() => {
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        {/* <FormGroupTitle>Figgers Coverage</FormGroupTitle> */}
                        <Typography className={classes.title}>Reconnect Phone Number</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        {/* <span className={classes.crossButton} onClick={handleClose}><img src={CloseIcon} alt="close" /></span> */}
                    </div>

                    {isLoading ? <DialogLoader></DialogLoader> : ''}
                    <div className={classes.content}>
                        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={600}>

                            <Grid container direction="column">
                                <Grid item lg={12}>
                                    <Label size={12} title={fromDashboard ? 'Enter phone number:' : 'Phone Number:'} mandatory={true} />

                                </Grid>
                                <Grid item lg={12}>
                                    <Grid item lg={12}>
                                        <InputBaseField
                                            id="mdnNumber"
                                            name="mdnNumber"
                                            value={state.mdnNumber}
                                            type="text"
                                            onChange={handleChange}
                                            placeholder='Phone number'
                                            IsDisabled={fromDashboard ? false : true}
                                            MaxLength={14}
                                        />
                                        {errorMessages.errorPhone && !state.mdnNumber ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter number
                                        </FormHelperText>) : ('')}
                                        {errorMessages.errorInvalidPhone && state.mdnNumber && !validatePhoneNumber(state.mdnNumber) ? (<FormHelperText style={{ color: "red" }} >
                                            Please enter valid phone number
                                        </FormHelperText>) : ('')}
                                    </Grid>
                                    {/*<Typography className={classes.valueText}>{formateMdnNumber(props.mdnNumber)}</Typography>*/}
                                </Grid>
                                <Grid item lg={12}>
                                    <Label size={12} title={'IMEI:'} />
                                </Grid>
                                {/*<Grid item lg={12}>
                                    <Typography className={classes.valueText}>{updateMdnNumber}</Typography>
                                </Grid>*/}
                                <Grid item lg={12}>
                                    <InputBaseField
                                        name="imei"
                                        value={state.imei}
                                        onChange={handleChange}
                                        placeholder="IMEI"
                                        type="text"
                                        MaxLength={15}
                                        onKeyPress={(e) => handleNumberKeyPress(e)}
                                    />
                                    {errorMessages.errorImei && (state.imei && state?.imei.length < 15) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid IMEI
                                    </FormHelperText>) : ('')}
                                </Grid>
                            </Grid>
                        </Scrollbars>
                    </div>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            {isLoading ?
                                <Button className={classes.changeBtn}>Reconnect</Button>
                                :
                                <Button className={classes.changeBtn}
                                    onClick={reconnectMDN}>Reconnect</Button>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}
export default withSnackbar(ChangePhoneNumberDialog);